import CancleOrderParts from "@dana/Icons/CancleOrderParts";
import CubeCheck from "@dana/Icons/CubeCheck";
import CubeClock from "@dana/Icons/CubeClock";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";

export interface OrderHistoryResultCountStyles {
    orderCountText?: TypographyPresentationProps;
    countsGrid?: GridContainerProps;
    countsGridItem?: GridItemProps;
    countsGridItemInner?: InjectableCss;
    countItemContent?: InjectableCss;
    orderType?: TypographyPresentationProps;
}

export const resultCountStyles: OrderHistoryResultCountStyles = {};

const styles = resultCountStyles;

const OrderHistoryResultCount: FC<WidgetProps> = () => {
    const ordersDataView = useContext(OrdersDataViewContext);

    if (!ordersDataView.value || !ordersDataView.pagination) {
        return null;
    }

    const { totalItemCount } = ordersDataView.pagination;
    const openordCount = ordersDataView?.properties?.openOrderCount;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <>
            <GridContainer {...styles.countsGrid}>
                <GridItem {...styles.countsGridItem}>
                    <StyledWrapper {...styles.countsGridItemInner}>
                        <Icon size={60} src={CubeClock} />
                        <StyledWrapper {...styles.countItemContent}>
                            <Typography {...styles.orderType}>{translate("Open Orders")}</Typography>
                            <Typography {...styles.orderCountText}>{openordCount}</Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.countsGridItem}>
                    <StyledWrapper {...styles.countsGridItemInner}>
                        <Icon size={60} src={CubeCheck} />
                        <StyledWrapper {...styles.countItemContent}>
                            <Typography {...styles.orderType}>{translate("Total Orders")}</Typography>
                            <Typography {...styles.orderCountText} data-test-selector="orderHistory_resultCount">
                                {totalItemCount}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.countsGridItem}>
                    <StyledWrapper {...styles.countsGridItemInner} className="order-details-box">
                        <Icon size={60} src={CancleOrderParts} />
                        <StyledWrapper {...styles.countItemContent} className="order-details-box-content">
                            <Typography as="p">
                                {translate("Click")} <Link href="/myaccount/openorders">{translate("'Open Order Details'")}</Link>{" "}
                                {translate("to Cancel Eligible Items.")}
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistoryResultCount,
    definition: {
        group: "Order History",
        displayName: "Result Count",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
    },
};

export default widgetModule;
